export class HttpError extends Error {
    public status: number

    constructor(message: string, status: number) {
        super(message)

        this.status = status
    }
}

export class ApiError extends HttpError {
    public code: string

    constructor(message: string, status: number, code: string) {
        super(message, status)

        this.code = code
    }
}

export class ValidationApiError extends ApiError {
    public fields: Record<string, { message: string }>

    constructor(message: string, status: number, code: string, fields: Record<string, { message: string }>) {
        super(message, status, code)

        this.fields = fields
    }
}
